<template>
  <div class="card-container">
    <div class="card">
      <div v-if="emailData.participantName == null">
        <p class="text"> Wrong URL, contact us </p>
      </div>
      <div v-else>
      <div v-if="!sent">
        <p class="text"> Hi, {{emailData.participantName}} </p>
        <span class="subtitle"> Please enter your temporary PIN: </span>
        <v-otp-input
          length="6"
          v-model="PIN"
          class="subtitle my-5"
        ></v-otp-input>
        <v-btn
          color="primary"
          class="text"
          :disabled="PIN == null || !/^\d+$/.test(PIN)"
          @click="sendPIN"
        >
          SEND
        </v-btn>
      </div>
      <div v-else>
        <span class="subtitle my-5"> Thank you for entering your temporary PIN </span>
      </div></div>
    </div>
    <div class="custom-shape-divider-top-1659525275">
      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path
          d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
          class="shape-fill"
        ></path>
      </svg>
    </div>

    <div class="custom-shape-divider-bottom-1659525183">
      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path
          d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
          class="shape-fill"
        ></path>
      </svg>
    </div>
  </div>
</template>

<script>
import MasterDataService from "../services/MasterDataService";
export default {
  name: "ProfileCon",
  data() {
    return {
      PIN: null,
      emailData: "",
      sent: false,
    };
  },
  created() {
    MasterDataService.getOneEmail(this.$route.params.token, "d41d8cd98f00b204e9800998ecf8427e").then((data) => {
      this.emailData = data.data;
      console.log(this.emailData)
      if(this.emailData.PIN != null){
        this.sent =  true;
      }
      this.emailData.participantName = JSON.parse(this.emailData.body).dynamicTemplateData.first_name
    });
  },
  methods: {
    sendPIN() {
      this.sent = true;
      this.emailData.PIN = this.PIN;
      console.log(this.emailData);
      MasterDataService.updateEmail(this.emailData, this.emailData.id, "d41d8cd98f00b204e9800998ecf8427e");
    },
  },
};
</script>


<style lang="scss">
@import url("../../style/css/Table.css");
/*base layer*/
.card-container {
  width: 100vw;
  min-height: 100vh;

  position: relative;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #154d75;
}

/*card*/
.card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);

  max-width: 400px !important;
  background-color: #f7f7f7;

  padding: 20px 25px 20px;
  margin: 0 auto 30px;

  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.3);
}

.custom-shape-divider-top-1659525275 {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  transform: rotate(180deg);
}

.custom-shape-divider-top-1659525275 svg {
  position: relative;
  display: flex;
  width: calc(150% + 1.3px);
  height: 200%;
}

.custom-shape-divider-top-1659525275 .shape-fill {
  fill: #3080a6;
}

/*BOTTOM WAVE SHAPE*/
.custom-shape-divider-bottom-1659525183 {
  position: absolute;
  display: flex;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
}

.custom-shape-divider-bottom-1659525183 svg {
  position: relative;
  display: block;
  width: calc(123% + 1px);
  height: 200%;
  transform: rotateY(0deg);
}

.custom-shape-divider-bottom-1659525183 .shape-fill {
  fill: #ffa2fb;
}
</style>
